import { BsPlusCircleFill } from 'react-icons/bs';
import './feedCard.css';

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
	setSelectedSection,
	setTab
} from '../../../redux/actions/sideBarAction';
import { useNavigate } from 'react-router-dom';

import placeholder from '../../../assets/images/img.jpg';
import { SelectionCardItem } from '../../Utils/Components/slection-card';

export default function Outreach() {
	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const dispatch = useDispatch();
	dispatch(setSelectedSection('Outreach'));
	dispatch(setTab('outreach'));

	const navigate = useNavigate();
	return (
		<div className="h-screen">
			<div
				// style={{ width: dimensions.width, height: dimensions.height }}
				className="dark:bg-gray-800 grid grid-cols-1 md:grid-cols-2  content-center w-full h-screen pt-6 pl-20 pr-4"
			>
				<SelectionCardItem
					name="All Campaigns"
					sec="10 Campaigns"
					path="./all-campaigns"
					imgPath={placeholder}
				/>
				<SelectionCardItem
					name="My Stats"
					sec="50% open rate"
					path="./analytics"
					imgPath={placeholder}
				/>
				<SelectionCardItem
					name="Contacted users"
					sec="345 contacted users"
					path="./all-contacted-users"
					imgPath={placeholder}
				/>
				<SelectionCardItem
					name="All sent emails"
					sec="467 sent email"
					path="./all-sent-emails"
					imgPath={placeholder}
				/>

				<BottomBtn
					name="Create a new emailing campaign"
					action={() => navigate('./create-campaign')}
				/>
			</div>
		</div>
	);
}

export const BottomBtn = ({
	name,
	action
}: {
	name: string;
	action: () => void;
}) => {
	return (
		<button
			className=" flex flex-row items-center justify-start w-6/12 mx-auto
					fixed left-20 right-8 bottom-2 p-0
					rounded-lg shadow-lg bg-purple-700 hover:bg-purple-800 px-2
					transition duration-500 ease-in-out h-12"
			onClick={action}
		>
			<PlusIcon />
			<h3
				className="font-semibold w-full
						bg-transparent outline-none
						ml-0 mr-auto
						text-white"
			>
				{name}
			</h3>
		</button>
	);
};

const PlusIcon = () => (
	<BsPlusCircleFill
		size="22"
		className="text-white dark:shadow-lg mx-2 dark:text-primary"
	/>
);
